import { createStore } from 'vuex'
import toolPages from '../stores/modules/toolPages'
import request from '@/utils/request'

export default createStore({
  state: {
    files: [],
    currentFile: null,
    sourceText: '',
    translatedText: '',
    selfTranslation: '', // 用户自译内容
    searchResults: [],
    searchQuery: '',
    terminologyResults: [],
    user: null,
    isLoggedIn: false,
    isAdmin: false,
    adminToken: localStorage.getItem('adminToken'),
    adminUsername: localStorage.getItem('adminUsername'),
    aiDialogVisible: false,
    aiDialogTitle: '',
    aiDialogContent: '',
    userStatus: null,
    lastStatusUpdate: null,
    showAdminLogin: false,
    statusUpdateTimer: null,
    noteDialogVisible: false,
    noteDialogTitle: '',
    fileList: [],
    folderList: [],
    selectedText: '',
    inlineProcessing: false,
    processingMessage: '',
    connectionStatus: true,
    contentAreaInstance: null,
    fileListCollapsed: localStorage.getItem('fileListCollapsed') === 'true'
  },
  mutations: {
    setFiles(state, files) {
      state.files = files
    },
    setCurrentFile(state, file) {
      state.currentFile = file
    },
    setSourceText(state, text) {
      state.sourceText = text
    },
    setTranslatedText(state, text) {
      state.translatedText = text
    },
    setSelfTranslation(state, text) {
      state.selfTranslation = text
    },
    setSearchResults(state, results) {
      state.searchResults = results
    },
    setSearchQuery(state, query) {
      state.searchQuery = query
    },
    setTerminologyResults(state, results) {
      state.terminologyResults = results
    },
    setUser(state, user) {
      state.user = user
      state.isLoggedIn = !!user
    },
    setUserStatus(state, status) {
      state.userStatus = status
    },
    setLastStatusUpdate(state, time) {
      state.lastStatusUpdate = time
    },
    setAdminToken(state, token) {
      console.log('设置管理员Token:', token)
      state.adminToken = token
      state.isAdmin = !!token
      if (token) {
        localStorage.setItem('adminToken', token)
        state.isAdmin = true
        // 确保管理员有完整权限
        state.userStatus = {
          isLoggedIn: true,
          status: 'admin',
          is_admin: true
        }
      } else {
        localStorage.removeItem('adminToken')
        localStorage.removeItem('adminUsername')
        state.isAdmin = false
        // 清除管理员权限
        if (state.userStatus?.status === 'admin') {
          state.userStatus = null
        }
      }
    },
    setAdminUsername(state, username) {
      console.log('设置管理员用户名:', username)
      state.adminUsername = username
      if (username) {
        localStorage.setItem('adminUsername', username)
      } else {
        localStorage.removeItem('adminUsername')
      }
    },
    setAiDialogVisible(state, visible) {
      state.aiDialogVisible = visible
    },
    setAiDialogTitle(state, title) {
      state.aiDialogTitle = title
    },
    setAiDialogContent(state, content) {
      state.aiDialogContent = content
    },
    setShowAdminLogin(state, show) {
      state.showAdminLogin = show
    },
    setStatusUpdateTimer(state, timer) {
      state.statusUpdateTimer = timer
    },
    setNoteDialogVisible(state, visible) {
      state.noteDialogVisible = visible
    },
    setNoteDialogTitle(state, title) {
      state.noteDialogTitle = title
    },
    setFileList(state, list) {
      state.fileList = list
    },
    setFolderList(state, list) {
      state.folderList = list
    },
    setSelectedText(state, text) {
      state.selectedText = text
    },
    setInlineProcessing(state, processing) {
      state.inlineProcessing = processing
    },
    setProcessingMessage(state, message) {
      state.processingMessage = message
    },
    setConnectionStatus(state, status) {
      state.connectionStatus = status
    },
    setContentAreaInstance(state, instance) {
      state.contentAreaInstance = instance
    },
    setFileListCollapsed(state, collapsed) {
      state.fileListCollapsed = collapsed
      localStorage.setItem('fileListCollapsed', collapsed)
    }
  },
  actions: {
    async fetchFiles({ commit }) {
      try {
        const response = await request.get('/api/files/list')
        commit('setFileList', response)
      } catch (error) {
        console.error('获取文件列表失败:', error)
        commit('setFileList', [])
      }
    },

    async initializeAuth({ commit, state }) {
      // 检查是否有管理员token
      if (state.adminToken) {
        try {
          const isValid = await request.get('/admin/check')
          if (!isValid) {
            commit('setAdminToken', null)
            commit('setAdminUsername', null)
          }
        } catch (error) {
          commit('setAdminToken', null)
          commit('setAdminUsername', null)
        }
      }
    },

    async adminLogout({ commit }) {
      commit('setAdminToken', null)
      commit('setAdminUsername', null)
    },

    async checkAdminStatus({ state, commit }) {
      if (!state.adminToken) {
        return false
      }
      try {
        await request.get('/admin/check')
        return true
      } catch (error) {
        commit('setAdminToken', null)
        return false
      }
    },

    async logout({ commit, state }) {
      try {
        // 清除定时器
        if (state.statusUpdateTimer) {
          clearInterval(state.statusUpdateTimer)
          state.statusUpdateTimer = null
        }

        commit('setUser', null)
        commit('setUserStatus', null)
        commit('setLastStatusUpdate', null)
      } catch (error) {
        console.error('退出登录失败:', error)
      }
    },

    // 打开汉译英笔记
    openChineseToEnglishNotes({ commit }, selectedText = '') {
      commit('setNoteDialogTitle', '汉译英笔记')
      commit('setNoteDialogVisible', true)
      if (selectedText) {
        commit('setSelectedText', selectedText)
      }
    },

    // 打开英译汉笔记
    openEnglishToChineseNotes({ commit }, selectedText = '') {
      commit('setNoteDialogTitle', '英译汉笔记')
      commit('setNoteDialogVisible', true)
      if (selectedText) {
        commit('setSelectedText', selectedText)
      }
    }
  },
  modules: {
    toolPages
  }
})